exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "svg{width:48px;height:48px;fill:#064273;margin-right:12px}.temp{font-size:48px;color:#064273;font-weight:700}p{margin:0}", ""]);
